<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(autofocus :placeholder='$t("shipments.notes_placeholder")' :danger="$v.form.notes.$invalid && $v.form.notes.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.notes') })" v-model="form.notes" :label='$t("shipments.notes")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Shipments')

export default {
  name: 'ModalShipments',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        notes: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible'
    ])
  }
}
</script>
